import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import classes from "./styles/style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import CustomButton from "../../assets/components/CustomButton";
import Loading from "../../assets/containers/loadingDialog";
import useHomeAddress from "../../assets/Hooks/getHomeAddress";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";
import RulesImg from "../../assets/images/common/rulesImg.png";
import CrossImg from "../../assets/images/common/crossGroup.svg";
import UsersRequests from "../../assets/services/user";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function AccessCheckV3() {
  const dispatch = useDispatch();
  const [failed, setFailed] = useState(false);
  const { currentUser } = useSelector(({ user }) => user);
  const checkAccessCalled = useRef(false);

  const navigate = useNavigate();
  const { homeAddress } = useHomeAddress();

  let query = useQuery();
  let redirect = query.get("redirect");
  let topic = query.get("topic");
  let type = query.get("type");
  let topicString = query.get("topicString");

  useEffect(() => {
    dispatch(UsersRequests.getme());
  }, [dispatch]);

  const checkAccess = useCallback(() => {
    appApi
      .post("/accesslist/check", {
        identifier:
          type === "CodeMeli"
            ? currentUser.nationalCode
            : currentUser.personnelCode,
        topic: topic,
        topicString: topic === "Other" ? topicString : null,
        type: type,
      })
      .then(() => {
        setTimeout(() => {
          window.location.replace(
            `${redirect}&${type}=${
              type === "CodeMeli"
                ? currentUser.nationalCode
                : currentUser.personnelCode
            }&fullName=${currentUser.fullName}&nationalCode=${
              currentUser.nationalCode
            }&personnelCode=${currentUser.personnelCode}&phone=${
              currentUser.phone
            }`
          );
        }, 2000);
      })
      .catch((error) => {
        setTimeout(() => {
          setFailed(true);
          errorHandler(error);
        }, 2000);
      });
  }, [currentUser, type, topic, topicString, redirect]);

  useEffect(() => {
    if (!topic || !type) {
      navigate(homeAddress, { replace: "true" });
    } else if (
      currentUser &&
      currentUser.fullName &&
      !checkAccessCalled.current
    ) {
      checkAccessCalled.current = true;
      checkAccess();
    }
  }, [currentUser, topic, type, navigate, homeAddress, checkAccess]);

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <div className={classes.accessContainer}>
          <div className={`${classes.accessContent} shadow-lg`}>
            <img src={failed ? CrossImg : RulesImg} alt="access-img" />
            <h4>{failed ? "خطا در اعتبار سنجی" : "در حال اعتبارسنجی"}</h4>
            {failed ? (
              <CustomButton
                color={"primary"}
                text={"رفتن به اعلان‌ها"}
                shadow={true}
                styles={{ maxWidth: "200px" }}
                clickHandler={() => navigate(homeAddress)}
              />
            ) : (
              <Loading
                className={"my-5 d-flex justify-content-center"}
                size={40}
              />
            )}
          </div>
        </div>
      </div>
    </AnimatedPageContainer>
  );
}
